// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"5dc4f2e3","38":"4c3fb29c","217":"333bdd35","415":"a620399f","431":"ffd25256","453":"3154de31","660":"dc1354b1","721":"420a116e"}[chunkId] + ".chunk.js";
};